import * as React from "react";
import { Download, X } from "lucide-react";

interface Props {
  count: number;
  onExport: () => void;
  onClear: () => void;
}

export function SelectionBar({ count, onExport, onClear }: Props): React.ReactElement {
  return (
    <div className="flex flex-wrap items-center gap-4 rounded-xl bg-text-primary px-4 py-3 text-[13px] text-white">
      <span className="rounded-full bg-brand-600 px-2.5 py-0.5 font-mono text-[12px] font-semibold text-white">
        {count}
      </span>
      <span>{count === 1 ? "linha selecionada" : "linhas selecionadas"}</span>
      <div className="ml-auto flex items-center gap-1.5">
        <button
          type="button"
          onClick={onExport}
          className="inline-flex h-[30px] items-center gap-1.5 rounded-md border border-white/20 bg-transparent px-3 text-[12px] font-medium text-white hover:bg-white/10"
        >
          <Download className="h-3 w-3" aria-hidden="true" /> Exportar
        </button>
        <button
          type="button"
          onClick={onClear}
          className="inline-flex h-[30px] items-center gap-1.5 rounded-md border border-white/20 bg-transparent px-3 text-[12px] font-medium text-white hover:bg-white/10"
        >
          <X className="h-3 w-3" aria-hidden="true" /> Limpar seleção
        </button>
      </div>
    </div>
  );
}
